import { inject } from "@angular/core";
import { collection, CollectionReference, doc, DocumentReference, Firestore } from "@angular/fire/firestore";

export abstract class DatabaseService {

  //#region Services
  private firestore: Firestore = inject(Firestore);
  //#endregion

  //#region Constructor
  /**
   * Initializes database service materials and parameters.
   */
  protected constructor(private databaseName: string) { }
  //#endregion

  //#region Collection Methods
  /**
   * Gets a collection reference from firestore.
   * 
   * @param path - Path segments to apply relative to the base collection.
   * @returns - The collection reference.
   */
  protected getCollection(...name: string[]): CollectionReference {
    return collection(this.firestore, this.databaseName, ...name);
  }

  /**
   * Gets a document reference from firestore.
   * 
   * @param collection - The collection reference to get the document from.
   * @param id - The id of the document to get.
   * @returns - The document reference.
   */
  protected getDocument(collection: CollectionReference, id: string): DocumentReference {
    return doc(collection, id);
  }
  //#endregion
}